module.exports = __webpack_public_path__ + "img/m-eln.b3a0f47a.svg";